export function runMechanicalLinter(text: string): string {
    if (!text) return text;

    let cleaned = text;

    // 1. Sanitização de Lixo e Artefatos (FRM-19)
    // Remover blocos de acentos graves (```)
    cleaned = cleaned.replace(/```[a-z]*\n/gi, '');
    cleaned = cleaned.replace(/```/g, '');

    // Remover Markdown (*, **, _, #)
    cleaned = cleaned.replace(/\*\*/g, '');
    cleaned = cleaned.replace(/\*/g, '');
    cleaned = cleaned.replace(/_/g, '');
    cleaned = cleaned.replace(/^#+\s/gm, '');

    const lines = cleaned.split('\n');

    // Regex para identificar Scene Headings e Extensões
    const SCENE_HEADING_REGEX = /^(INT\.|EXT\.|INT\.\/EXT\.|I\/E\.)/i;
    // Regex for extensions (V.O.), (O.S.), (CONT'D)
    const EXTENSION_REGEX = /^\s*\((V\.O\.|O\.S\.|CONT'D|CONT’D)\)\s*$/i;

    for (let i = 0; i < lines.length; i++) {
        let line = lines[i];
        let trimmed = line.trim();
        if (!trimmed) continue;

        // 2. Imposição de Cabeçalhos de Cena (FRM-13, FRM-01, FRM-04)
        if (SCENE_HEADING_REGEX.test(trimmed)) {
            // FRM-13: Caixa Alta Obrigatória
            line = line.toUpperCase();

            // FRM-04: Hierarquia Invertida (LOCAL, SUBLOCAL -> LOCAL - SUBLOCAL)
            if (line.includes(',')) {
                line = line.replace(/,/g, ' -');
            }

            // FRM-01: Validar final com separador de tempo e etc.
            // E.g., Replace en dashes with hyphens and ensure spaces
            line = line.replace(/–/g, '-');
            // Normalize spaces around the final hyphen or any hyphen separating parts
            line = line.replace(/\s*-\s*/g, ' - ');

            lines[i] = line;
            continue;
        }

        // 3. Personagens e Extensões
        // Glue Rule (FRM-02) and Character Caps (CHR-02) 
        // Fountain convention: purely uppercase line (with optional spaces) that is followed by a non-empty line (dialogue or parenthetical)
        // Sometimes it's hard to distinguish purely uppercase action vs character name without looking ahead
        // We will do a safe heuristic: if it's completely uppercase, not a scene heading, and the next physical text line is dialogue/parenthetical.

        // For now, let's process Extensions (FRM-14)
        // If this line is just an extension like (V.O.), pull it to the previous line.
        if (EXTENSION_REGEX.test(trimmed)) {
            // Find the previous non-empty line
            let prevIdx = i - 1;
            while (prevIdx >= 0 && lines[prevIdx].trim() === '') {
                prevIdx--;
            }
            if (prevIdx >= 0) {
                // Append it to the character name
                lines[prevIdx] = lines[prevIdx] + ' ' + trimmed.toUpperCase();
                lines[i] = ''; // Remove this line
            }
        }
    }

    // Re-join the lines
    cleaned = lines.join('\n');

    // Glue Rule (FRM-02): Remover linhas em branco entre Nome do Personagem e Diálogo
    // Wait, doing this via simple Regex could break. 
    // Let's rely on standard Fountain format where Character Name is all caps, optionally followed by space, 
    // and the next text must be dialogue. But it's easier to leave it for now or use a basic regex.

    // 4. Rubricas (DLG-06): Diálogo não pode começar na mesma linha em que a rubrica fecha o parêntese `)`.
    // Regex: `\)(?=\s*[A-Za-z0-9])` -> replaced with `)\n`
    // Wait, if it's `(smiling) Hi`, we change it to `(smiling)\nHi`.
    // Ensure we match closing parenthesis followed by whitespace then dialogue text.
    cleaned = cleaned.replace(/\)(\s*)(?=[A-Za-z0-9À-ÖØ-öø-ÿ\"])/g, ')\n');

    // FRM-02 (Glue rule) basic regex:
    // If we have an uppercase line (character) followed by blank lines then a parenthesis or text.
    // In pure fountain, there are no blank lines between character and dialogue.
    // `^([A-ZÀ-ÖØ-öø-ÿ0-9\s]+(\(V\.O\.\)|\(O\.S\.\)|\(CONT'D\))?)\n\n+([A-Za-z0-9À-ÖØ-öø-ÿ\(]+)`
    // Actually, CHR-02 (Character Uppercase) is hard to reliably catch with purely mechanical regex without full parsing context
    // Let's at least ensure parentheticals don't have dialogue on the same line.

    return cleaned;
}
